import {
  SiteIncident,
  CreateSiteIncidentRequest,
  UpdateSiteIncidentRequest,
} from '../models/SiteIncident';
import { API_ENDPOINTS } from '../config/api';
import { apiClient } from './api/apiClient';
import {
  ApiItemResponse,
  ApiListResponse,
  ApiOkResponse,
  ensureOk,
  unwrapItem,
  unwrapList,
} from './api/response';

export class SiteIncidentService {
  static async list(projectId: number): Promise<SiteIncident[]> {
    const response = await apiClient.get<ApiListResponse<SiteIncident>>(
      API_ENDPOINTS.SITE_MANAGEMENT.INCIDENTS.LIST(projectId),
    );
    return unwrapList(response, '장애 이력 목록 조회 실패');
  }

  static async get(incidentId: number): Promise<SiteIncident> {
    const response = await apiClient.get<ApiItemResponse<SiteIncident>>(
      API_ENDPOINTS.SITE_MANAGEMENT.INCIDENTS.GET(incidentId),
    );
    return unwrapItem(response, '장애 이력 조회 실패');
  }

  static async create(projectId: number, data: CreateSiteIncidentRequest): Promise<SiteIncident> {
    const response = await apiClient.post<ApiItemResponse<SiteIncident>>(
      API_ENDPOINTS.SITE_MANAGEMENT.INCIDENTS.CREATE(projectId),
      data,
    );
    return unwrapItem(response, '장애 이력 생성 실패');
  }

  static async update(incidentId: number, data: UpdateSiteIncidentRequest): Promise<SiteIncident> {
    const response = await apiClient.put<ApiItemResponse<SiteIncident>>(
      API_ENDPOINTS.SITE_MANAGEMENT.INCIDENTS.UPDATE(incidentId),
      data,
    );
    return unwrapItem(response, '장애 이력 수정 실패');
  }

  static async delete(incidentId: number): Promise<void> {
    const response = await apiClient.delete<ApiOkResponse>(
      API_ENDPOINTS.SITE_MANAGEMENT.INCIDENTS.DELETE(incidentId),
    );
    ensureOk(response, '장애 이력 삭제 실패');
  }
}
